import React from 'react';
import { Link } from '../../common/Link';
import { getClassNames } from 'js/utils/classNames.util';

import * as constants from './constants';

import style from './Button.scss';

export const Button = ({
    href,
    status,
    children,
    className,
    classname,
    size = 'large',
    type = 'button',
    view = 'primary',
    color = 'success',
    variant = 'regular',
    ...props
}) => {
    const { VIEWS, VARIANTS, COLORS, SIZES, STATUSES } = constants;
    const classNames = getClassNames([
        className,
        classname,
        style.btn,
        style[SIZES[size]],
        style[STATUSES[status]],
        style[VIEWS[view]],
        style[COLORS[color]],
        style[VARIANTS[variant]]
    ]);

    return href
        ? (
            <Link
                href={href}
                className={classNames}
                {...props}>
                {children}
            </Link>
        )
        : (
            <button
                type={type}
                className={classNames}
                {...props}>
                {children}
            </button>
        );
};
